import {
  Avatar,
  Card,
  CardActionArea,
  Typography,
  styled,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import { APP_BACKGROUND_COLOR, APP_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const useStyles = makeStyles({
  customTextField: {
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
});

export const ModalBox = styled(Box)(({ theme }) => ({
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  border: "none",
  borderRadius: "10px",
  boxShadow: "24",
  padding: 25,
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    width: "90vw",
    height: "70%",
  },
  [theme.breakpoints.down("md")]: {
    width: "75vw",
  },
  [theme.breakpoints.up("md")]: {
    width: "45vw",
  },
}));

export const ResponsiveCenteredBox = styled(Box)(({ theme }) => ({
  display: "flex",
  marginBottom: "20px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    justifyContent: "center",
  },
}));

export const FilterContainer = styled(Box)(({ theme }) => ({
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "10px",
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: "0px",
  },
}));

export const SortContainer = styled(Box)(({ theme }) => ({
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    marginLeft: "0px",
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: "10px",
  },
}));

export const filterTextStyle = {
  borderStyle: "solid",
  border: 0.5,
  borderRadius: 1,
  paddingX: 1,
  height: 40,
  justifyContent: "center",
  color: "white",
  borderColor: "white",
  "& .MuiInput-underline:before": { display: "none" },
  "& .MuiInput-underline:after": { display: "none" },
};

export const StyledText = styled("div")(() => ({
  alignItems: "center",
  fontSize: "20px",
  color: "GrayText",
  marginTop: "20px",
  display: "flex",
  justifyContent: "center",
}));

export const StyledProfilePic = styled(Avatar)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "2px",
  color: "white",
  background: "#242424",
  flex: "none",
  order: "0",
  flexGrow: "0",
  zIndex: "0",
  borderRadius: "50%",
  ":hover": {
    transform: "scale(1.1)",
  },
  [theme.breakpoints.up("md")]: {
    width: "2.5vw",
    height: "2.5vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "5vw",
    height: "5vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "8vw",
    height: "8vw",
  },
}));

export const GridContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  padding: 0,
  margin: 0,
  gap: "30px",
  width: "100%",
  alignItems: "center",
  justifyItems: "center",
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(4,1fr)",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(2,1fr)",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(1,1fr)",
  },
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  margin: 0,
  padding: 0,
  width: "20vw",
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
  borderRadius: 15,
  backgroundColor: APP_BACKGROUND_COLOR,
  color: "white",
  [theme.breakpoints.up("md")]: {
    width: "22vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "40vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "85vw",
  },
}));

export const StyledCardActionArea = styled(CardActionArea)(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  backgroundColor: APP_BACKGROUND_COLOR,
  overflow: "hidden",
}));

export const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  margin: 0,
  padding: 0,
  ".MuiCardMedia-img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    preload: "none",
  },
  transition: "transform 2s",
  ":hover": {
    transform: "scale(1.1)",
  },
  [theme.breakpoints.up("md")]: {
    width: "22vw",
    height: "22vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "40vw",
    height: "40vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "85vw",
    height: "85vw",
  },
}));

export const StyledCardText = styled(Typography)(({ theme }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontFamily: FONT_FAMILY,
  [theme.breakpoints.up("md")]: {
    width: "10vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "20vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "45vw",
  },
}));

export const styles = {
  avatarGroup: {
    "& .MuiAvatar-root": {
      fontSize: 18,
      fontFamily: FONT_FAMILY,
      backgroundColor: "#25486e",
      color: "#cfcfcf",
    },
  } as const,
  card: {
    boxShadow: "none",
    borderRadius: "0",
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
  } as const,
  cardActionArea: {
    display: "inline-block",
    width: "100%",
    backgroundColor: APP_BACKGROUND_COLOR,
    overflow: "hidden",
  } as const,
  cardMedia: {
    display: "block",
    width: "100%",
    height: "400px",
    transition: "transform 2s",
    ":hover": {
      transform: "scale(1.1)",
    },
  } as const,
  styledProfilePic: {
    width: "40px",
    height: "40px",
    marginLeft: "2px",
    color: "white",
    backgroundColor: APP_COLOR,
  } as const,
  navLink: {
    textDecoration: "none",
    color: "black",
    margin: "auto",
  } as const,
  navLinkAvatar: {
    textDecoration: "none",
    color: "black",
    margin: "auto",
    marginLeft: 2,
    marginRight: 2,
  } as const,
  contributorsContainer: {
    display: "flex",
    alignItems: "left",
    margin: "10px",
    justifyContent: "center",
  } as const,
  icon: {
    height: 25,
    width: 25,
  } as const,
  infoContainer: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: APP_BACKGROUND_COLOR,
    alignItems: "center",
    pb: 0.6,
  } as const,
  iconContainer: {
    display: "flex",
    alignItems: "center",
    ml: 0.2,
  } as const,
  featuredHeading: {
    textAlign: "left",
    margin: "10px 0px 15px 0px",
    borderBottom: "1px solid #cfcfcf",
    fontWeight: "bold",
    fontSize: "24px",
    fontFamily: FONT_FAMILY,
  } as const,
  linearProgressContainer: {
    alignContent: "center",
    height: "30vh",
    width: "100%",
  } as const,
  sortSelect: {
    width: 250,
    height: 40,
    marginRight: 0.5,
    fontFamily: FONT_FAMILY,
  } as const,
};

export const modalStyles = {
  contributorsHeading: {
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    marginRight: "5px",
  } as const,
  contributorsPhotoContainer: {
    display: "flex",
    color: "black",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  contributorNavLink: {
    marginRight: "5px",
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    color: APP_COLOR,
  } as const,
  contributorsPhotos: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginBottom: "5px",
  } as const,
  openSeaLinkContainer: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  openSeaImage: {
    width: "22px",
    marginRight: 5,
    color: "black",
  } as const,
  openSeaUrl: {
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    color: APP_COLOR,
  } as const,
  description: {
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
  } as const,
};

export const FlexContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2,1fr)",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(1,1fr)",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const DescriptionContainer = styled(Box)(({ theme }) => ({
  color: TEXT_COLOR,
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

export const ContributorsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  color: TEXT_COLOR,
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
  },
}));

export const TrackContainer = styled("div")(({ theme }) => ({
  backgroundColor: "#C1b2b",
  width: "100%",
  borderRadius: 15,
  display: "flex",
  marginBottom: 20,
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

export const TrackImage = styled("img")(({ theme }) => ({
  borderRadius: 10,
  [theme.breakpoints.down("sm")]: {
    width: 250,
    height: 250,
    marginBottom: 10,
  },
  [theme.breakpoints.up("sm")]: {
    width: 200,
    height: 200,
  },
}));

export const TrackContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingLeft: 15,
  paddingRight: 15,
  width: "100%",
}));

export const TrackMetadata = styled("div")(({ theme }) => ({
  height: "25%",
  alignItems: "center",
  display: "flex",
}));

export const WaveformContainer = styled("div")(({ theme }) => ({
  height: "50%",
  alignItems: "center",
  display: "flex",
}));

export const trackStyles = {
  title: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: "bold",
  } as const,
  genreLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: "white",
    marginRight: 2,
  } as const,
  genre: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: TEXT_COLOR,
  },
};
